import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

// --full: the homepage design fills the whole section with blue rather than floating a blue card
// on a light background. Scoped via the modifier — .lp-cta is shared by ten other pages.
const HomeCtaSection = () => (
    <section className="lp-cta lp-cta--full">
        <div className="lp-cta-card" data-lp-reveal>
            <div className="lp-cta-inner">
                <h2>Let's discuss how we can help you beat the odds and create value</h2>
                <p className="sub">Join 50+ investors, advisors, and companies already using the platform. Start free — no credit card required.</p>
                <div className="lp-cta-btns">
                    <Link className="lp-cta-btn" to={ROUTES.REGISTER}>Get started free</Link>
                    <a className="lp-cta-btn lp-cta-btn--outline" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Book a demo call</a>
                </div>
            </div>
        </div>
    </section>
);

export default HomeCtaSection;
